import clsx from "clsx";
import Button from "@/components/Button";
import styles from "./ReviewClientTasksContentPanel.module.scss";

type ReviewClientTasksNextRowProps = {
  isNextRowElevated: boolean;
  isNextStepBlocked: boolean;
  isBulkSimplifyJobBusy: boolean;
  isBulkTranslationWorkInProgress: boolean;
  onNext: () => void;
};

export default function ReviewClientTasksNextRow(
  props: ReviewClientTasksNextRowProps,
) {
  return (
    <div
      className={clsx(
        styles.nextRow,
        props.isNextRowElevated && styles.reviewTasksNextAboveLockedOverlay,
      )}
    >
      <Button
        data-testid="next-button"
        variant="default"
        disabled={
          props.isNextStepBlocked ||
          props.isBulkSimplifyJobBusy ||
          props.isBulkTranslationWorkInProgress
        }
        loading={props.isBulkTranslationWorkInProgress}
        onClick={props.onNext}
      >
        Next
      </Button>
    </div>
  );
}
